import { Close as CloseIcon, Warning } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import LoadingButton from "../../components/LoadingButton";
import { hostname, parseError } from "../../utils";

export default ({
  open,
  onClose,
  list,
  getToken,
  eventListener,
  companyId,
}: {
  open: boolean;
  onClose: () => void;
  list: any;
  getToken: Function;
  eventListener: Function;
  companyId: string;
}) => {
  const [loading, setLoading] = useState(false);
  const [listName, setListName] = useState("");
  const [validForm, setValidForm] = useState(false);

  const handleClose = () => {
    setListName("");
    setValidForm(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (!validForm) return;
    setLoading(true);
    const currentToken = await getToken();
    
    const updatedList = {
      ...list,
      name: listName.trim(),
    };

    axios
      .put(
        `${hostname}/lists`,
        updatedList,
        {
          headers: { Authorization: `Bearer ${currentToken}` },
        }
      )
      .then(() => {
        handleClose();
      })
      .catch((err) => {
        eventListener({
          type: "SET_ERROR",
          error: parseError(err),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (list && open) {
      setListName(list.name || "");
    }
  }, [list, open]);

  useEffect(() => {
    const hasName = listName && listName.trim().length > 0;
    const isDifferent = list && listName.trim() !== list.name;
    setValidForm(hasName && isDifferent);
  }, [listName, list]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Edit List Name
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent style={{ paddingTop: "16px" }}>
        <Typography variant="body2" style={{ marginBottom: "16px" }}>
          Update the name of your smart list. This will change how it appears
          throughout the application.
        </Typography>
        <TextField
          fullWidth
          label="List Name"
          value={listName}
          onChange={(e) => setListName(e.target.value)}
          placeholder="Enter list name"
          variant="outlined"
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{ marginRight: "8px" }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled
          sx={{ display: validForm ? "none" : "block" }}
        >
          <Warning fontSize="small" style={{ marginRight: "4px" }} />
          {!listName?.trim() ? "Name Required" : "No Changes"}
        </Button>
        <LoadingButton
          sx={{ display: validForm ? "flex" : "none" }}
          loading={loading}
          onClick={handleSubmit}
          variant="contained"
        >
          Save Changes
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};